export const convertToDate = (str) => {
    if (!str) return false;
    var parts = str.split("/");
    if (parts.length !== 3) return null;
    var year = parseInt(parts[2], 10);
    var month = parseInt(parts[1], 10);
    var day = parseInt(parts[0], 10);

    if (!year || !month || !day || year < 1000) return null;

    var date = new Date(year, month, day);

    if (isNaN(date.getTime())) return null;

    return date;
};

export const isValidDate = (str) => {
    const date = convertToDate(str);
    return date !== null;
};

export const isMinAge = (str, minAge) => {
    const date = convertToDate(str);

    if (date === null) return false;

    const now = new Date();

    const currentYear = now.getFullYear();
    const dobYear = date.getFullYear();

    const yearDiff = currentYear - dobYear;

    if (yearDiff > minAge) return true;
    if (yearDiff < minAge) return false;

    const currentMonth = now.getMonth() + 1;
    const dobMonth = date.getMonth();

    const monthDiff = currentMonth - dobMonth;

    if (monthDiff > 0) return true;
    if (monthDiff < 0) return false;

    const currentDay = now.getDate();
    const dobDay = date.getDate();
    const dayDiff = currentDay - dobDay;
    return dayDiff > 0;
};
